export enum CommonSections {
    Campaigns = 'campaigns-section',
}

export enum HomePageSections {
    Hero = 'homepage-hero',
    Unlock = 'homepage-unlock',
    Works = 'homepage-works',
    FAQS = 'homepage-faqs',
    FiftyPlus = 'homepage-fifty-plus',
    Testimonials = 'homepage-testimonials',
    Join = 'homepage-join',
    Experience = 'homepage-experience',
    Campaigns = CommonSections.Campaigns,
}

export enum CampaignsPageSections {
    Hero = CommonSections.Campaigns,
    Works = 'campaigns-works',
    Join = 'campaigns-join',
    Network = 'campaigns-network',
    Powerful = 'campaigns-powerful',
}

export enum FaqsPageSections {
    Hero = 'faqs-hero',
    Join = 'faqs-join',
}

export enum FulfillmentPageSections {
    Hero = 'fulfillment-hero',
    Join = 'fulfillment-join',
}

export enum PrivacyPageSections {
    Hero = 'privacy-hero',
    Join = 'privacy-join',
}

export enum ContactPageSections {
    Hero = 'contact-hero',
}
